import { gql } from '@apollo/client';
import { TREATMENT } from './Treatment';

export const IBC_REVIEW = gql`
  fragment IbcReview on IbcReview {
    id
    createdAt
    reconRepId
    reconRep {
      id
      userId
      email
    }
    instructionId
    beforeTreatmentId
    beforeTreatment {
      ...Treatment
    }
    afterTreatmentId
    afterTreatment {
      ...Treatment
    }
    beforeTokenParam1
    beforeTokenParam2
    afterTokenParam1
    afterTokenParam2
    beforeNotes
    afterNotes
    beforePublicNotes
    afterPublicNotes
    transactionHash
  }
  ${TREATMENT}
`;
